import React, { useState, useEffect } from "react";
import { Loader, Pagination } from "semantic-ui-react";
import { map, size } from "lodash";
import { Post } from "../../../../api";
import { PostItem } from "../PostItem";
import "./ListPost.scss";

const postController = new Post();

export function ListPost(props) {
  const { reload, onReload } = props;

  const [posts, setPosts] = useState(null);
  const [pagination, setPagination] = useState(null);
  const [page, setPage] = useState(1);

  useEffect(() => {
    (async () => {
      try {
        const response = await postController.getPosts(page);
        setPosts(response.posts.docs);
        //console.log(response);
        setPagination({
          total: response.posts.totalDocs,
          page: response.posts.page,
          limit: response.posts.limit,
          pages: response.posts.totalPages,
        });
      } catch (error) {
        console.log(error);
      }
    })();
  }, [page, reload]);

  const changePage = (e, data) => {
    setPage(data.activePage);
  };

  if (!posts) return <Loader active inline="centered" />;
  if (size(posts) === 0) return <h2>No hay posts</h2>;

  return (
    <div className="list-post">
      {map(posts, (post) => (
        <PostItem key={post._id} post={post} onReload={onReload} />
      ))}

      <div className="list-post__pagination">
        <Pagination
          defaultActivePage={pagination.page}
          totalPages={pagination.pages}
          ellipsisItem={null}
          firstItem={null}
          lastItem={null}
          onPageChange={changePage}
        />
      </div>
    </div>
  );
}
